import { useCallback, useEffect, useState } from "react";
import { createLivenessSession, livenessStatus } from "../../api/liveness";

// AWS Face Liveness availability + one single-use session per attempt.
export const useLivenessSession = () => {
  const [enabled, setEnabled] = useState(false);
  const [region, setRegion] = useState("");
  const [sessionId, setSessionId] = useState(null);

  useEffect(() => {
    livenessStatus()
      .then((res) => {
        setEnabled(Boolean(res.enabled));
        setRegion(res.region || "");
      })
      .catch(() => setEnabled(false));
  }, []);

  const newSession = useCallback(async () => {
    if (!enabled) return null;
    try {
      const res = await createLivenessSession();
      setSessionId(res.session_id);
      return res.session_id;
    } catch {
      setEnabled(false);
      setSessionId(null);
      return null;
    }
  }, [enabled]);

  const clear = useCallback(() => setSessionId(null), []);

  return { enabled, region, sessionId, newSession, clear };
};
